const form = document.getElementById('create_customer');
const formPost = async newFormData => {
  await fetch('https://app.madeinevolve.com/_shopify-utils/romboitaly/create-customers', {
    method: 'POST',
    headers: {
      'content-Type': 'application/json'
    },
    body: JSON.stringify(newFormData)
  }).then(response => {
    if (response.status === 200) {
      console.log(response);
      alert('Hai salvato i dati con sucesso');
    } else {
      console.log(response.status);
      alert('Errore, prova più tardi');
    }
  });
};
if (form) {
  form.addEventListener('submit', e => {
    e.preventDefault();
    const formData = new FormData(form);
    // output as an object
    const data = Object.fromEntries(formData);
    console.log(data);
    const newFormData = {
      email: data.customer_email,
      first_name: data.customer_first_name,
      last_name: data.customer_last_name,
      phone: data.customer_telephone,
      tags: [`agent_id:${data.customer_agent_id}`, `brand:${data.customer_brand}`, `company:${data.customer_company}`, `payment:${data.customer_payment}`, `vat_number:${data.customer_vat_number}`],
      default_address: {
        address1: data.customer_address,
        zip: data.customer_cap,
        city: data.customer_city,
        province: data.customer_province
      }
    };
    formPost(newFormData);
    //form.submit();
  });
}
